var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nyx-spinner",class:{
 'nyx-spinner--large': _vm.isLarge,
 'mx-auto': _vm.isLarge,
}})
}
var staticRenderFns = []

export { render, staticRenderFns }